import { render } from "./DetailsEvent.vue?vue&type=template&id=54ae3ba4&scoped=true"
import script from "./DetailsEvent.vue?vue&type=script&lang=js"
export * from "./DetailsEvent.vue?vue&type=script&lang=js"

import "./DetailsEvent.vue?vue&type=style&index=0&id=54ae3ba4&scoped=true&lang=css"

import exportComponent from "d:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ae3ba4"]])

export default __exports__